<div class="container" rtl>
  <div class="row">
    <div class="col-12">
      <h1 class="main-heading">Dettagli</h1>
      <mat-list>
        <p mat-list-item role="listitem">
          <strong>Numero: </strong>
          <span>{{ pratica.prtNumero }}</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>Prodotto: </strong>
          <span>{{ pratica.prtCategoriaProdotto === 'C' ? 'Cessione' : 'Delega'}}</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>Impiego: </strong>
          <span>{{ pratica.prtTpprDescrizione | titlecase }}</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>Rata: </strong>
          <span>{{ pratica.prtImportoRata | currency:'EUR' }}</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>Durata: </strong>
          <span>{{ pratica.prtNumeroRate }}</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>TAN: </strong>
          <span>{{ pratica.prtTan | number:'1.4' }} %</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>TAEG: </strong>
          <span>{{ pratica.prtTaeg | number:'1.4' }} %</span>
        </p>
        <p mat-list-item role="listitem">
          <strong>Importo: </strong>
          <span>{{ pratica.prtImportoNetto | currency:'EUR' }}</span>
        </p>
      </mat-list>
    </div>
  </div>
</div>
